import { JobAPIType, AuthUserType } from "../../../Actions/Types"
import { Reducer } from "redux"
import { JobsDownload } from "../../../Models/API/JobModel"
import { AuthAction } from "../../Auth"
import { APIAppAsyncOperationModel } from "../../../Models/API/APIAppAsyncOperationModel"

export interface DownloadOperation {
    id?: number
    operation?: APIAppAsyncOperationModel
    downloadURL?: string
}

export interface JobsDownloadState {
    [appID: string]: {
        downloadOperation?: DownloadOperation
        download: JobsDownload | undefined
    }
}

interface GetJobsDownloadAction {
    type: JobAPIType.download
    meta: {
        appID: string
    }
    payload: JobsDownload
}

interface ClearJobsDownloadAction {
    type: JobAPIType.clearDownload
    payload: string
}

interface SetDownloadOperationIdAction {
    type: JobAPIType.downloadOperationId
    meta: {
        appID: string
    }
    payload: number
}

interface SetDownloadOperationAction {
    type: JobAPIType.setDownloadOperation
    meta: {
        appID: string
    }
    payload: APIAppAsyncOperationModel
}

export type JobsDownloadAction =
    | GetJobsDownloadAction
    | ClearJobsDownloadAction
    | SetDownloadOperationIdAction
    | SetDownloadOperationAction

const initialState: JobsDownloadState = {}

export const JobsDownloadReducer: Reducer<
    JobsDownloadState,
    JobsDownloadAction | AuthAction
> = (state = initialState, action): JobsDownloadState => {
    switch (action.type) {
        case JobAPIType.download:
            return {
                ...state,
                [action.meta.appID]: {
                    ...state[action.meta.appID],
                    download: action.payload
                }
            }
        case JobAPIType.clearDownload:
            return initialState
        case JobAPIType.downloadOperationId:
            return {
                ...state,
                [action.meta.appID]: {
                    ...state[action.meta.appID],
                    downloadOperation: {
                        id: action.payload,
                        operation: undefined
                    }
                }
            }
        case JobAPIType.setDownloadOperation:
            return {
                ...state,
                [action.meta.appID]: {
                    ...state[action.meta.appID],
                    downloadOperation: {
                        ...state[action.meta.appID].downloadOperation,
                        operation: action.payload
                    }
                }
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
